// Webpack Imports


import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TweenMax, Power2} from 'gsap';

gsap.registerPlugin(ScrollTrigger);

const isMobile = window.matchMedia("(max-width: 768px)").matches;

let menu = document.querySelector(".menu-authors-home");
const menuItems = gsap.utils.toArray(".menu-authors-element");

menuItems.forEach((menuItem, index) => {
  const startPosition = index % 2 === 0 ? "-="+screen.width/2 : "+="+screen.width/2;
  const endPosition = index % 2 === 0 ? (60*index) : (-60*index);

  const animationProps = {
    x: endPosition,
    opacity: 1,
    duration: 1,
    delay: index * 0.5,
    ease: "power2.in"
  };

  if (isMobile) {
    // Adjust animation properties for mobile
    animationProps.x = 0;
    animationProps.opacity = 1;
    animationProps.duration = 0.75;
    animationProps.delay = index * 0.25;
  }

  gsap.fromTo(
    menuItem,
    {
      opacity: 0,
      x: startPosition
    },
    {
      ...animationProps
    }
  );
});



/*

const portraits = document.querySelectorAll('.framed');
portraits.forEach((element) => {
		const animation = TweenMax.from(element, 1, {
			opacity: 0.2,
			filter: blur(1.5),
			ease: Power2.out, 
			duration:2,
			paused: true,
		});
	
function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

// ...

elements.forEach((element) => {
	if (isInViewport(element)) {
		animation.play();
	} else {
		animation.reverse();
	}
});


function handleScroll() {
	if (isInViewport(element)) {
	
	  animation.play();
	} else {
	
	  animation.reverse();
	}
  }
  
 
  window.addEventListener('scroll', handleScroll);

});
*/
//An Hour Adrift by Ezra Skull (c) copyright 2023 Licensed under a Creative Commons Attribution Noncommercial  (3.0) license. https://dig.ccmixter.org/files/Haskel/66099 Ft: Airtone
//An Hour Adrift by Ezra Skull (c) copyright 2023 Licensed under a Creative Commons Attribution Noncommercial  (3.0) license. https://dig.ccmixter.org/files/Haskel/66099 Ft: Airtone

  




      




	
	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );



// Get the reference to the <p> element
//const sonettoUrlElement = document.getElementById('sonetto-url');

// Get the text content of the <p> element
//const sonettoUrlText = sonettoUrlElement.textContent;


	 
	 /*
	
	  //carrusel
	  var hCarousel = document.getElementById('carouselHomes')
	  console.log(hCarousel);
	  var carousel = new bootstrap.Carousel(hCarousel, {
		interval: 2000,
		wrap: false
	  })

	carousel.cycle();
	 
	*/
	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );


	
		document.addEventListener('DOMContentLoaded', function () {
			// Get the value from the element with id "timeline"
			const timelineElement = document.getElementById('timeline-items');
			const timelineValue = parseInt(timelineElement.textContent);
		  
			// Get the current value of the --items CSS variable
			const currentItemsValue = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--items'));
			console.log(currentItemsValue);
			// Update the CSS variable value only if it's different
			if (timelineValue !== currentItemsValue) {
				document.documentElement.style.setProperty('--items', timelineValue);
				console.log(timelineValue);
				const currentItemsValue = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--items'));
				console.log(currentItemsValue);
				
				
			}
		});
		

